// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page */
.notifPage{
  background: var(--white-principale);
  min-height: 100vh;
  padding: 12px 0 26px;
  font-family: Arial, sans-serif;
}

/* Breadcrumb */
.notifBreadcrumb{
  font-size: 12px;
  color: var(--gris-terciaire);
  display:flex;
  align-items:center;
  gap: 8px;
  margin: 4px 0 14px;
}
.notifBreadcrumb .sep{ color: var(--gris-principale); }
.notifBreadcrumb .active{ color: var(--couleur-principale); font-weight: 600; }

/* On centre la carte principale */
.notifGrid{
  display:flex;
  justify-content: center;
}

/* Cards */
.notifCard{
  border-radius: 12px;
  background: var(--white-principale);
  box-shadow: 0 1px 10px rgba(0,0,0,.14);
  padding: 16px;
}

/* Card centrée + largeur contrôlée */
.notifCardCenter{
  width: 100%;
  max-width: 820px;
  margin-top: 16px;
}

/* ✅ Header : titre à gauche, bouton à droite */
.notifHeader{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

/* Titre */
.notifCardTitle{
  font-weight: 800;
  font-size: 13px;
  color: var(--couleur-dark);
  margin: 0; /* important pour l’alignement avec le bouton */
}

/* List */
.notifList{
  display:flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.notifItem{
  display:flex;
  gap: 12px;
  align-items:flex-start;
  padding: 10px 10px;
  border-radius: 10px;
  border: 1px solid var(--gris-secondaire-2);
  background: var(--white-principale);
}

.notifDot{
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: var(--couleur-principale);
  margin-top: 4px;
  flex: 0 0 auto;
}

.notifItem.read .notifDot{
  background: var(--gris-principale);
}

.notifMain{
  min-width: 0;
  flex: 1 1 auto;
}

.notifRowTop{
  display:flex;
  align-items:center;
  justify-content: space-between;
  gap: 10px;
}

.notifLabel{
  font-weight: 800;
  font-size: 12px;
  color: var(--couleur-dark);
  overflow:hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.notifTime{
  font-size: 11px;
  color: var(--gris-terciaire);
  flex: 0 0 auto;
}

.notifDesc{
  margin-top: 4px;
  font-size: 12px;
  color: var(--gris-terciaire);
  line-height: 1.25;
}

/* Actions row under list */
.notifActions{
  margin-top: 14px;
  display:flex;
  justify-content: center;
}

/* Bouton (style principal) */
.notifBtn{
  width: 100%;
  max-width: 360px;
  height: 40px;
  border: none;
  border-radius: 999px;

  background: var(--couleur-principale);
  color: var(--white-principale);

  font-weight: 800;
  letter-spacing: .02em;
  cursor: pointer;
  transition: background .15s ease, filter .15s ease, opacity .15s ease;
}

/* ✅ Version petite du bouton (header) */
.notifBtnSmall{
  width: auto;
  max-width: none;
  height: 30px;
  padding: 0 12px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: .01em;
  white-space: nowrap;
}

/* Hover */
.notifBtn:hover{
  background: var(--couleur-secondaire);
  filter: none;
}

/* Disabled */
.notifBtn:disabled{
  opacity: .55;
  cursor: default;
}
.notifBtn:disabled:hover{
  background: var(--couleur-principale);
  filter: none;
}

/* ===== Responsive ===== */
@media (max-width: 720px){
  .notifBreadcrumb{
    flex-wrap: wrap;
    row-gap: 6px;
  }

  .notifHeader{
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .notifBtnSmall{
    width: 100%;
    height: 36px; /* plus confortable en mobile */
    padding: 0 14px;
    text-align: center;
  }

  .notifItem{
    padding: 10px;
  }

  .notifLabel{
    white-space: normal;
  }

  .notifActions{
    justify-content: stretch;
  }

  .notifBtn{
    max-width: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/notification/NotificationsPage.css"],"names":[],"mappings":"AAAA,SAAS;AACT;EACE,mCAAmC;EACnC,iBAAiB;EACjB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,eAAe;EACf,4BAA4B;EAC5B,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;AACpB;AACA,uBAAuB,6BAA6B,EAAE;AACtD,0BAA0B,gCAAgC,EAAE,gBAAgB,EAAE;;AAE9E,kCAAkC;AAClC;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA,UAAU;AACV;EACE,mBAAmB;EACnB,mCAAmC;EACnC,sCAAsC;EACtC,aAAa;AACf;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,SAAS,EAAE,+CAA+C;AAC5D;;AAEA,SAAS;AACT;EACE,YAAY;EACZ,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,0CAA0C;EAC1C,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,oBAAoB;;EAEpB,qCAAqC;EACrC,8BAA8B;;EAE9B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qEAAqE;AACvE;;AAEA,wCAAwC;AACxC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,aAAa;AACb;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY,EAAE,+BAA+B;IAC7C,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Page */\n.notifPage{\n  background: var(--white-principale);\n  min-height: 100vh;\n  padding: 12px 0 26px;\n  font-family: Arial, sans-serif;\n}\n\n/* Breadcrumb */\n.notifBreadcrumb{\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  display:flex;\n  align-items:center;\n  gap: 8px;\n  margin: 4px 0 14px;\n}\n.notifBreadcrumb .sep{ color: var(--gris-principale); }\n.notifBreadcrumb .active{ color: var(--couleur-principale); font-weight: 600; }\n\n/* On centre la carte principale */\n.notifGrid{\n  display:flex;\n  justify-content: center;\n}\n\n/* Cards */\n.notifCard{\n  border-radius: 12px;\n  background: var(--white-principale);\n  box-shadow: 0 1px 10px rgba(0,0,0,.14);\n  padding: 16px;\n}\n\n/* Card centrée + largeur contrôlée */\n.notifCardCenter{\n  width: 100%;\n  max-width: 820px;\n  margin-top: 16px;\n}\n\n/* ✅ Header : titre à gauche, bouton à droite */\n.notifHeader{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n/* Titre */\n.notifCardTitle{\n  font-weight: 800;\n  font-size: 13px;\n  color: var(--couleur-dark);\n  margin: 0; /* important pour l’alignement avec le bouton */\n}\n\n/* List */\n.notifList{\n  display:flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.notifItem{\n  display:flex;\n  gap: 12px;\n  align-items:flex-start;\n  padding: 10px 10px;\n  border-radius: 10px;\n  border: 1px solid var(--gris-secondaire-2);\n  background: var(--white-principale);\n}\n\n.notifDot{\n  width: 10px;\n  height: 10px;\n  border-radius: 999px;\n  background: var(--couleur-principale);\n  margin-top: 4px;\n  flex: 0 0 auto;\n}\n\n.notifItem.read .notifDot{\n  background: var(--gris-principale);\n}\n\n.notifMain{\n  min-width: 0;\n  flex: 1 1 auto;\n}\n\n.notifRowTop{\n  display:flex;\n  align-items:center;\n  justify-content: space-between;\n  gap: 10px;\n}\n\n.notifLabel{\n  font-weight: 800;\n  font-size: 12px;\n  color: var(--couleur-dark);\n  overflow:hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.notifTime{\n  font-size: 11px;\n  color: var(--gris-terciaire);\n  flex: 0 0 auto;\n}\n\n.notifDesc{\n  margin-top: 4px;\n  font-size: 12px;\n  color: var(--gris-terciaire);\n  line-height: 1.25;\n}\n\n/* Actions row under list */\n.notifActions{\n  margin-top: 14px;\n  display:flex;\n  justify-content: center;\n}\n\n/* Bouton (style principal) */\n.notifBtn{\n  width: 100%;\n  max-width: 360px;\n  height: 40px;\n  border: none;\n  border-radius: 999px;\n\n  background: var(--couleur-principale);\n  color: var(--white-principale);\n\n  font-weight: 800;\n  letter-spacing: .02em;\n  cursor: pointer;\n  transition: background .15s ease, filter .15s ease, opacity .15s ease;\n}\n\n/* ✅ Version petite du bouton (header) */\n.notifBtnSmall{\n  width: auto;\n  max-width: none;\n  height: 30px;\n  padding: 0 12px;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: .01em;\n  white-space: nowrap;\n}\n\n/* Hover */\n.notifBtn:hover{\n  background: var(--couleur-secondaire);\n  filter: none;\n}\n\n/* Disabled */\n.notifBtn:disabled{\n  opacity: .55;\n  cursor: default;\n}\n.notifBtn:disabled:hover{\n  background: var(--couleur-principale);\n  filter: none;\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 720px){\n  .notifBreadcrumb{\n    flex-wrap: wrap;\n    row-gap: 6px;\n  }\n\n  .notifHeader{\n    flex-direction: column;\n    align-items: stretch;\n    gap: 10px;\n  }\n\n  .notifBtnSmall{\n    width: 100%;\n    height: 36px; /* plus confortable en mobile */\n    padding: 0 14px;\n    text-align: center;\n  }\n\n  .notifItem{\n    padding: 10px;\n  }\n\n  .notifLabel{\n    white-space: normal;\n  }\n\n  .notifActions{\n    justify-content: stretch;\n  }\n\n  .notifBtn{\n    max-width: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
